import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { client } from "../../../App";
import { convertTime } from "../../../helpers/helpers";
import { GET_LIST_READING } from "../../../helpers/queries";
import { hideLoading, showLoading } from "../../../reducers/app";
import FiltersBox from "../../common/FiltersBox/FiltersBox";
import Hero from "../../common/Hero/Hero";
import NoResult from "../../common/NoResult/NoResult";
import ContarctListWrapper from "../ContractsPage/ContractListWrapper/ContractListWrapper";
import "./SelfReadingListPage.scss";

const SelfReadingListPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selfReadings, setSelfReadings] = useState([]);
  const [filters, setFilters] = useState({});
  const [filteredSelfReadings, setFilteredSelfReadings] = useState([]);
  const listSelfReading = async () => {
    return client()
      .query({
        query: GET_LIST_READING,
        variables: {},
      })
      .then((response) => {
        const { data } = response;
        if (data) {
          const { listReading = null } = data;
          if (listReading) {
            const { readings = [] } = listReading;
            return readings.reduce((acc, curr) => {
              const {
                accountholderId,
                contractId,
                accountholder,
                data,
                reading,
              } = curr;
              acc.push({
                codiceintestatario: accountholderId,
                codicecontratto: contractId,
                denominazioneintestatario: accountholder,
                datalettura: convertTime(data),
                lettura: reading,
              });
              return acc;
            }, []);
          }
        }
        return [];
      })
      .catch((e) => console.log(e, "sono qui"));
  };
  const onFiltersChanged = (e) => {
    console.log("SET FILTERED", e);
    console.log(filters);
    setFilters(e);
  };
  const columns = React.useMemo(
    () => [
      {
        Header: t("bo_operator.self_reading_list.table.codiceintestatario"),
        accessor: "codiceintestatario",
        id: 1,
      },
      {
        Header: t("bo_operator.self_reading_list.table.codicecontratto"),
        accessor: "codicecontratto",
        id: 2,
      },
      {
        Header: t(
          "bo_operator.self_reading_list.table.denominazioneintestatario"
        ),
        accessor: "denominazioneintestatario",
        id: 3,
      },
      {
        Header: t("bo_operator.self_reading_list.table.datalettura"),
        accessor: "datalettura",
        id: 4,
      },
      {
        Header: t("bo_operator.self_reading_list.table.lettura"),
        accessor: "lettura",
        id: 5,
      },
    ],
    [t]
  );
  const filterConfig = {
    fields: [
      {
        label: t("bo_operator.self_reading_list.filters.codiceintestatario"),
        name: "codiceintestatario",
        type: "input",
        leftIcon: "lens",
        columnSize: "4",
      },
      {
        label: t("bo_operator.self_reading_list.filters.codicecontratto"),
        name: "codicecontratto",
        type: "input",
        leftIcon: "lens",
        columnSize: "4",
      },
    ],
  };
  useEffect(() => {
    dispatch(showLoading());
    listSelfReading()
      .then((data) => {
        setSelfReadings(data ? data : []);
        dispatch(hideLoading());
      })
      .catch((e) => {
        dispatch(hideLoading());
        console.log(e);
      });
  }, [dispatch]);
  return (
    <div className="SelfReadingListPage" data-testid="SelfReadingListPage">
      <Hero
        backTo={"/"}
        backToText={t("bo_operator.self_reading_list.back.home")}
        title={t("bo_operator.self_reading_list.title_header")}
        description={
          <Trans i18nKey={"bo_operator.self_reading_list.help_test_header"}>
            <Link to={"/autolettura"} />
          </Trans>
        }
      />
      <FiltersBox
        checkContractStatus={true}
        config={filterConfig}
        onChange={onFiltersChanged}
        data={selfReadings}
        onDataFiltered={setFilteredSelfReadings}
        filter={(data, filters) => {
          const { codiceintestatario = null, codicecontratto = null } = filters;
          if (codiceintestatario) {
            return data.filter(
              (element) => element.codiceintestatario === codiceintestatario
            );
          }
          if (codicecontratto) {
            return data.filter(
              (element) => element.codicecontratto === codicecontratto
            );
          }
          return data;
        }}
      />
      {selfReadings.length > 0 ? (
        <ContarctListWrapper
          hideData={true}
          columns={columns}
          data={filteredSelfReadings}
          orderColumns={[]}
          isDisablePage={false}
          t={t}
        />
      ) : (
        <NoResult text={t("online.bills.noResults")} />
      )}
    </div>
  );
};

export default SelfReadingListPage;
